import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  form: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  formContent: {
    flexGrow: '1',
    padding: '32px',
    minHeight: '500px',
    '& .MuiAlert-root': {
      width: 'calc(100% + 64px)',
      marginLeft: '-32px'
    }
  },
  tooglerTooltip: {
    '& div + div': {
      marginTop: '18px'
    }
  },
  togglerWrapper: {
    marginTop: '18px',
    display: 'inline-block',
    marginRight: '10px'
  },
  tooglerTooltipTrigger: {
    '& path': {
      fill: palette.info.main
    }
  },
  formFooter: {
    borderTop: "1px solid ".concat(palette.shades[400]),
    padding: '32px 40px'
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  footerButton: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    }
  },
  footerWrapper: {
    display: 'flex'
  },
  roleSelector: {
    display: 'flex',
    '& .MuiTypography-root': {
      padding: '8px 8px 8px 0px'
    },
    '& .MuiSvgIcon-root path': {
      fill: palette.info.main
    }
  },
  portfoliosAccordions: {
    overflowX: 'hidden',
    maxHeight: '420px'
  }
}));
export default useStyles;